<div class="mb-3">
	<mat-checkbox
		color="primary"
		matTooltip="Produkty-bliźniaki dzielą wspólną pulę miejsc Pakietu Komfort w terminach o tych samych datach"
		[ngModel]="enabled()"
		(ngModelChange)="toggleEnabled($event)"
		[disabled]="editable()"
	>
		Transport bliźniak – Pakiet Komfort
	</mat-checkbox>

	@if (enabled()) {
		<ng-select
			class="mt-2"
			id="comfortTwinProducts"
			name="comfortTwinProducts"
			bindValue="id"
			bindLabel="label"
			[placeholder]="'Wyszukaj produkty-bliźniaki (min. ' + MIN_SEARCH_LENGTH + ' znaki)'"
			[items]="productOptions()"
			[multiple]="true"
			[loading]="productsLoading()"
			[typeahead]="productsSearch$"
			[disabled]="editable()"
			[ngModel]="selectedProductIds()"
			(ngModelChange)="selectProducts($event)"
		>
		</ng-select>
	}
</div>
